import { useSyncExternalStore } from 'react'

const DESKTOP_QUERY = '(min-width: 1024px)'

const mq =
  typeof window !== 'undefined' ? window.matchMedia(DESKTOP_QUERY) : null

function subscribe(cb: () => void) {
  mq?.addEventListener('change', cb)
  return () => mq?.removeEventListener('change', cb)
}

function getSnapshot() {
  return mq?.matches ?? false
}

function getServerSnapshot() {
  return false
}

/**
 * Returns `true` when the viewport matches the desktop breakpoint (≥1024px),
 * mirroring Tailwind's `lg:` prefix. Reactive — updates on resize.
 */
export function useIsDesktop() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
